import '@fontsource-variable/inter';
import '@fontsource-variable/inter/wght-italic.css';
import '@fontsource-variable/jetbrains-mono';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import './assets/styles/main.css';
import { router } from './router';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
